import axios from 'axios'
import { getApiUrl, hasPandora, getValueFormatted } from '../utils/utils'
import { FETCH_DETAIL, FETCH_DETAIL_FAILURE, createUrl } from './detail'
import { FETCH_CATEGORIES_SUCCESS } from './categories'
import { FETCH_AVERAGEPRICE } from './averagePrice'

let httpAgent, httpsAgent
if (typeof window === 'undefined') {
  // eslint-disable-next-line
  const http = require(/* webpackIgnore: true */ 'http')
  // eslint-disable-next-line
  const https = require(/* webpackIgnore: true */ 'https')
  httpAgent = new http.Agent({ keepAlive: true })
  httpsAgent = new https.Agent({ keepAlive: true })
}

/**
 * Thunk único para SSR que busca detail, categories e averagePrice
 * em uma única promise chain. Evita despachar múltiplos thunks que
 * causam colisão de hash no redux-universal.
 */
export function fetchAdDetailSSR(detailData, vehicleType) {
  const detailUrl = createUrl(detailData)
  const pandora = hasPandora()

  const SSR_TIMEOUT = 8000

  const axiosOpts = { params: { pandora }, timeout: SSR_TIMEOUT, httpAgent, httpsAgent }

  return (dispatch) => {
    return axios
      .get(detailUrl, axiosOpts)
      .then(detailRes => {
        dispatch({
          type: FETCH_DETAIL,
          payload: detailRes.data,
          requested: detailData,
        })

        const formattedId = getValueFormatted(detailRes.data.UniqueId)
        const catUrl = `${getApiUrl()}category`
        const avgUrl = `${getApiUrl()}detail/averageprice/${vehicleType}/${formattedId}`

        return Promise.allSettled([
          axios
            .get(catUrl, axiosOpts)
            .then(res =>
              dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: res.data })
            )
            .catch(() => {}),
          axios
            .get(avgUrl, axiosOpts)
            .then(res =>
              dispatch({ type: FETCH_AVERAGEPRICE, payload: res.data })
            )
            .catch(() => {}),
        ])
      })
      .catch(err => {
        dispatch({
          type: FETCH_DETAIL_FAILURE,
          payload: err.stack,
          errorStatus: err.response?.status || null,
          requested: detailData,
        })
      })
  }
}
